import { mapState } from 'vuex';
import $ from 'jquery';
import 'jquery-validation';
import 'jquery-ui/ui/widgets/tooltip';
import KsGroupSelect from 'ksc-vue-ui2/src/components/KsSelect/index.vue';
import KsServerIp from 'ksc-vue-ui2/src/components/KsServerIp/index.vue';
import EventHub from 'ksc-vue-ui2/src/services/EventHub';
// import KsDialog from 'ksc-vue-ui2/src/components/dialog/index.vue';
import KsDataList from 'ksc-vue-ui2/src/components/KsDatalist/index.vue';
// import ToolTip from '../KecSeries/Tooltip/Tooltip.vue';
import Tooltip from 'kpc/components/tooltip';
import KecSelect from '../KecSeries/kecSelect/select.vue';
import * as step4Const from '../../store/create/step4/constants';
import commonAlert from '../../services/common/alert';
import { Button, ButtonGroup } from 'kpc/components/button';
import { Tabs, Tab } from 'kpc/components/tabs';
import { Select, Option } from 'kpc/components/select';
import Radio from 'kpc/components/radio';
import Dialog from 'kpc/components/dialog';
import Checkbox from 'kpc/components/checkbox';
import Input from 'kpc/components/input';
import {Collapse, CollapseItem} from 'kpc/components/collapse';
import Vue from 'vue';
import Message from 'kpc/components/message';
import KSwitch from 'kpc/components/switch';
import Datepicker from 'kpc/components/datepicker';
import * as commonConst from '../../store/common/constants';
import Icon from 'kpc/components/icon';
import _ from 'lodash';
import ToolTip from 'kpc/components/tooltip';

import * as productService from '../../services/kec/product'
import Card from 'kpc/components/card';

function createLoginModeOptions(self) {
    let imageType = self.imageType || 0;
    let imageObj = self.imageObj;
    let imageVersion = !_.isEmpty(imageObj) ? (imageObj.imageVersion || imageObj.Platform) : 0;
    let isWindows = false;
    self.cloudInitSupport = !_.isEmpty(imageObj) ? imageObj.CloudInitSupport : false;

    let pwdLogin = {
        title: self.$trans(`密码`), //'密码',
        value: 'password',
    };
    let sshLogin = {
        title: self.$trans(`密钥`), //'密钥',
        value: 'useHaveSSH',
    };
    let imgLogin = {
        title: self.$trans(`保留镜像设置`), //'保留镜像设置',
        value: 'useImageConfig',
    };
    let randomPwdLogin = {
        title: self.$trans(`创建后设置`), //'创建后设置'（原：自动生成密码）
        value: 'randomPassword',
    };

    if (imageVersion) {
        isWindows = /win.*/i.test(imageVersion.toLowerCase());
        self.isWindows = isWindows;

        let isAndroidImage = /android.*/i.test(imageVersion.toLowerCase());
        let isOtherLinux = imageVersion.toLowerCase() == 'other-linux';
        self.isAndroidImage = isAndroidImage;
        if (isOtherLinux || isAndroidImage) {
            return [imgLogin];
        }
    }

    // if (imageVersion && imageVersion.toLowerCase() == 'other-linux') {
    //     return [imgLogin];
    // }

    if (isWindows) {
        if (imageType == 1 || imageType == 3) { //自定义镜像、共享镜像
            return [pwdLogin, imgLogin, randomPwdLogin];
        } else {
            return [pwdLogin, randomPwdLogin];
        }
    } else {
        if (imageType == 1 || imageType == 3) { //自定义镜像、共享镜像
            return [pwdLogin, sshLogin, imgLogin, randomPwdLogin];
        } else {
            return [pwdLogin, sshLogin, randomPwdLogin];
        }
    }
}

function initLoginMode(self) {
    let imageType = self.imageType || 0;
    let imageObj = self.imageObj;
    let isWindows = false;
    let imageVersion = !_.isEmpty(imageObj) ? (imageObj.imageVersion || imageObj.Platform) : 0;
    // if (imageType == 1 || imageType == 3 || (imageVersion && imageVersion.toLowerCase() == 'other-linux')) {
    //     return 'useImageConfig';
    // }
    if (imageVersion) {
        isWindows = /win.*/i.test(imageVersion.toLowerCase());

        let isAndroidImage = /android.*/i.test(imageVersion.toLowerCase());
        let isOtherLinux = imageVersion.toLowerCase() == 'other-linux';
        if (imageType == 1 || imageType == 3 || isOtherLinux || isAndroidImage) {
            return 'useImageConfig';
        }
    }
    return isWindows ? 'password' : 'useHaveSSH'; //产品需求 非window镜像开机默认使用密钥
}

export default {
    name: 'Create-Step4',
    components: {
        KsGroupSelect,
        KsServerIp,
        EventHub,
        Tooltip,
        KsDataList,
        KecSelect,
        Button,
        ButtonGroup,
        Tabs,
        Tab,
        Select,
        Option,
        Radio,
        Dialog,
        Checkbox,
        Input,
        Message,
        KSwitch,
        Datepicker,
        Collapse,
        CollapseItem,
        Icon,
        Card,
        ToolTip,
    },
    props: {
        admin_account: {
            type: String,
            default: 'kingsoft'
        },
        kecType: {
            type: Number,
            default: 41,
        },
        regionKey: {
            type: String,
            default: 'cn-qingyangtest-1'
        },
        kecCount: {
            type: Number,
            default: 10,
        },
        isCluster: {
            type: Boolean,
            default: false
        },
        imageType: {
            type: Number,
            default: 0
        },
        imageObj: {
            type: Object,
            default: () => { }
        },
        dedicatedObj: {
            type: Object,
            default: () => { }
        },
        DstartTempData: {
            type: Object,
            default: () => {}
        },
        DtheSameConfigData: {
            type: Object,
            default: () => {}
        },
        DsourcePage: {
            type: String,
            default: ''
        },
        billType:{
            default: ''
        },
        isSendByApi:{
            type:Boolean
        },
        isSaveTemplate:{
            type:Boolean
        }
    },
    data() {
        return {
            loginMode: initLoginMode(this),
            loginModeOptions: createLoginModeOptions(this),
            isShow: false,
            projectnames: [],
            checkedProject: {},
            serverName: '',
            isAddSuf: true,
            tagKeyList: [],
            avoidList: [],
            password: '',
            rePassword: '',
            instanceNameSuffixol: 1,
            checkAvoidStatus: false,
            newAvoidGroupName: '', //新建的名称
            avoidNameList: [], //用于校验重复名称
            avoidObj: {},
            avoidValue:'',  //cb729567-606c-4f49-bf09-7b7c5e37735f
            avoidPrice: 0.00,
            avoidCreate: 'no',
            tipStatus: false,
            sameStatus: false,
            tipinfo: '',
            tagValueList: [],
            hasAvoidConfig: true,
            isServeName: true,
            isShowPassword: true,
            selectKeyId: '',
            sshList: [],
            showErrorInfo: false,
            isCreateSSH: false,
            pages: { limit: 500 }, //默认获取500条数据
            isAdvancedOptions: false, //高级选项菜单
            hostName: '',
            userData: '',
            userBase64: false,
            isAddHostNameSuf: true,
            isHostNameValid: true,
            hostNameSuffixol: 1,
            tagSelectList:[],
            modelName: '',
            showModelName: false,
            showTagBox: true,
            isTiming:false,
            todelTime:'',
            minTime:'',
            deltimeError:false,
            autoDeleteEip: false,
            checkedProjectValue:'',
            expandMoreOption:false,
            kecIamRolesList: [], //kec服务下所有IAM角色列表
            kecIamRoleId: '',
            kecIamRoleName: '',
            tagKey:'',
            tagValue:'',
            learnMore:'',
            isRockylinuxImage: false,
            isAutoDelete: false,
            showAutoDelete: false,
            isProtect: false,
            addTagToDisk: false,
        };
    },
    created() {
        // this.SKIP = window.KSC_SECNET_CONSOLE.BASE_HOST;
        this.SKIP = _.get(window, 'KSC_SECNET_CONSOLE.BASE_HOST', 'console.ksyun.com');
        this.pageLanguage = window.KSC_SECNET_CONSOLE.LANG || 'zh';
        // if(this.pageLanguage === 'zh'){
        //     this.learnMore = '//docs.ksyun.com/documents/5409'
        // } else {
        //     this.learnMore = '//endocs.ksyun.com/documents/5409'
        // }
        // if (this.SKIP != 'console.ksyun.com') {
        //     window.location.href = '/';
        // }
        // $.when(this._fetchProjectList(),this._fetchTagData(),this._fetchAvoidList(),this._fetchAvoidConfig())
    },
    computed: {
        ...mapState({
            projectlist: state => state.__pbc__.step4.projectlist,
            tagKeySet: state => state.__pbc__.step4.tagKeySet,
            avoidListSet: state => state.__pbc__.step4.avoidListSet,
            tagValueSet: state => state.__pbc__.step4.tagValueSet,
            avoidSet: state => state.__pbc__.step4.avoidSet, //权限
            createAvoidSet: state => state.__pbc__.step4.createAvoidSet,
            describeKecIamRoles: state => state.__pbc__.step4.describeKecIamRoles,
            keySet: state => state.__pbc__.step4.keySet,
            pcommon: state => state.__pbc__.common,
        }),
        imageChangeData(){
            return {
                Platform: this.imageObj?.Platform,
                imageType: this.imageType,
                imageVersion: this.imageObj?.imageVersion
            }
        },
        isDpu(){
            return this.kecType === 713 || this.kecType === 714;
        }
    },
    methods: {
        showAddTemplate(){
            this.$parent.addTemplateNameDia = true
        },
        isCommonModelType() {
            return commonConst.isCommonModelType(this.kecType);
        },
        // isGpuModelType() {
        //     // return commonConst.isGpuModelType(this.kecType);
        //     return productService.isGPU(this.kecType);
        // },
        isSupportAvoid() {
            return productService.isSupportAvoid(this.kecType);
        },
        //初始化
        setInitData(params) {
            _.map(_.keys(params), (key) => {
                if (key != 'isShow') {
                    this[key] = params[key];
                }
            });
            if (this.hasPrecondition) {
                return this.preconditionFunc(params.isShow);
            } else {
                this.isShow = params.isShow || false;
            }
        },
        preconditionFunc(isShow) {
            var promise = $.Deferred();
            if (this.isCluster) {
                promise = $.when(this._fetchProjectList(), this._fetchTagData(), this._getSSHData(), this._getKecIamRoles())
            } else {
                promise = $.when(this._fetchProjectList(), this._fetchTagData(), this._getSSHData(), this._getKecIamRoles(), this._fetchAvoidList(), this._fetchAvoidConfig(), this._fetchDate())
            }

            return promise.then((res) => {

            }, (e) => {

            }).then(() => {
                this.isShow = isShow;
                if (this.DsourcePage == 'createTemplate' || this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate') {
                    this.fetchStartTemplate();
                }
                if (this.DsourcePage == 'createTheSameConfig') {
                    this.fetchCreateTheSameConfig();
                }

            });
        },
        //获取kec服务下所有IAM角色列表
        _getKecIamRoles() {
            return this.$store.dispatch(step4Const.describeKecIamRoles, {
                options: {
                    isJSON: true
                },
                params: {
                    Region: this.regionKey
                }
            }).then((res) => {
                this.kecIamRolesList = _.get(res, 'ListRolesResult.Roles.member', []);
            }).catch(e => {
                Message.error(e || e.msg);
            });
        },
        fetchStartTemplate() {
            // if (this.DsourcePage == 'createTemplate' || this.DsourcePage == 'modifyTemplate') {
            //     this.showTagBox = false;
            // }
            if (this.DsourcePage == 'createTemplate' || this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate') {
                this.showModelName = true;
                this.loginModeOptions = _.filter(createLoginModeOptions(this), function (item) {
                    return item.value != 'password';
                });
                this.loginMode = this.loginModeOptions[0].value;
            }
            if ((this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate') && Object.keys(this.DstartTempData).length) {
                var base64Reg = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2,16384}==)$/;
                let data = this.DstartTempData;
                this.loginMode = _.get(data, 'KeepImageLogin', '') ? 'useImageConfig' : _.get(data, 'KeyId', '') ? 'useHaveSSH' : 'randomPassword';
                this.hostName = _.get(data, 'HostName', '');
                let userData = _.get(data, 'UserData', '');
                if (base64Reg.test(userData)) {
                    // userData = atob(userData);
                    userData = Buffer.from(userData, 'base64').toString('utf8')
                }
                if (userData.length || this.hostName.length) {
                    this.isAdvancedOptions = true;
                }
                this.userData = userData;
                this.userBase64 = false;

                //通过ProjectId查找项目制列表是否有对应的选项
                this.checkedProject = _.find(this.projectnames, (item) => {
                    return item.ProjectId == _.get(data, 'projectInfo.ProjectId');
                }) || this.projectnames[0];
                this.serverName = _.get(data, 'InstanceName');
                this.modelName = _.get(data, 'ModelName');

                //通过KeyId查找密钥列表是否有对应的选项
                let sshKey = _.find(this.sshList, function (item) {
                    return item.KeyId == _.get(data, 'KeyId', '');
                })
                setTimeout(() => {
                    this.selectKeyId = sshKey ? sshKey.KeyId : "";
                    if (this.selectKeyId == "" && this.loginMode == 'useHaveSSH') {
                        Message.error(this.$trans(`所选密钥对已被删除，请重新选择`)); //所选密钥对已被删除，请重新选择!
                    }
                })

                let tagSet = _.get(data, 'TagSet', []);
                if(tagSet.length) {
                    _.forEach(tagSet, (item) => {
                        item.tagKey = item.Key,
                        item.tagValue = item.Value
                    });
                    this.tagSelectList = tagSet;
                    this.addTagToDisk = _.get(data, 'SyncTag', false);
                }

                // window系统不支持密钥登录
                // if (isWindows && this.loginMode == 'useHaveSSH') {
                //     this.loginMode = 'randomPassword';
                //     this.selectKeyId = '';
                // }

                //通过DataGuardId查找容灾组列表是否有对应的选项
                if (_.get(data, 'DataGuardId', '')) {
                    this.avoidObj = _.find(this.avoidList, function (item) {
                        return item.value == _.get(data, 'DataGuardId', '');
                    }) || {};
                    if (!Object.keys(this.avoidObj).length || this.avoidObj.less == 0) {
                        Message.error(this.$trans(`容灾组已满或已不存在，请重新选择`)); //容灾组已满或已不存在，请重新选择!
                    }
                }


                let IamRoleName = _.get(data, 'IamRoleName', '');
                if (IamRoleName) {
                    let IamRole = _.find(this.kecIamRolesList, ['RoleName', IamRoleName]) || {};
                    if (!_.isEmpty(IamRole)) {
                        this.kecIamRoleId = IamRole.RoleId;
                    } else {
                        Message.error(this.$trans(`输入的IAM角色无效`)); //输入的IAM角色无效
                    }
                }

                this.isAutoDelete = _.get(data, 'FailureAutoDelete', false);

                this.isProtect = _.get(data, 'IsProtect', false);
            }
        },

        fetchCreateTheSameConfig() {
            this.showModelName = false;
            // this.loginModeOptions = _.filter(createLoginModeOptions(this), function (item) {
            //     return item.value != 'password';
            // });
            this.loginMode = this.loginModeOptions[0].value;

            if (Object.keys(this.DtheSameConfigData).length) {
                var base64Reg = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2,16384}==)$/;
                let data = this.DtheSameConfigData;
                const keyId = _.get(data, 'KeySet[0]', '')
                if (_.get(this.imageObj, 'imageId', '') == data.ImageId) {
                    this.loginMode = _.get(data, 'KeepImageLogin', '') ? 'useImageConfig' : keyId ? 'useHaveSSH' : 'randomPassword';
                }
                this.hostName = _.get(data, 'HostName', '');
                let userData = _.get(data, 'UserData', '');
                if (base64Reg.test(userData)) {
                    // userData = atob(userData);
                    userData = Buffer.from(userData, 'base64').toString('utf8')
                }
                // if (userData.length || this.hostName.length) {
                //     this.isAdvancedOptions = true;
                // }
                this.userData = userData;
                this.userBase64 = false;

                //通过ProjectId查找项目制列表是否有对应的选项
                this.checkedProject = _.find(this.projectnames, (item) => {
                    return item.ProjectId == _.get(data, 'projectInfo.ProjectId');
                }) || this.projectnames[0];
                this.serverName = _.get(data, 'InstanceName');
                this.modelName = _.get(data, 'ModelName');

                //通过KeyId查找密钥列表是否有对应的选项
                let sshKey = _.find(this.sshList, function (item) {
                    return item.KeyId == keyId;
                })
                setTimeout(() => {
                    this.selectKeyId = sshKey ? sshKey.KeyId : "";
                    if (this.selectKeyId == "" && this.loginMode == 'useHaveSSH') {
                        Message.error(this.$trans(`所选密钥对已被删除，请重新选择`)); //所选密钥对已被删除，请重新选择!
                    }
                })


                // window系统不支持密钥登录
                // if (isWindows && this.loginMode == 'useHaveSSH') {
                //     this.loginMode = 'randomPassword';
                //     this.selectKeyId = '';
                // }

                //通过DataGuardId查找容灾组列表是否有对应的选项
                if (_.get(data, 'DataGuardSet[0].DataGuardId', '')) {
                    this.avoidObj = _.find(this.avoidList, function (item) {
                        return item.value == _.get(data, 'DataGuardSet[0].DataGuardId', '');
                    }) || {};
                    if (!Object.keys(this.avoidObj).length || this.avoidObj.less == 0) {
                        Message.error(this.$trans(`容灾组已满或已不存在，请重新选择`)); //容灾组已满或已不存在，请重新选择!
                    }
                }

                let IamRoleName = _.get(data, 'IamRoleName', '');
                if (IamRoleName) {
                    let IamRole = _.find(this.kecIamRolesList, ['RoleName', IamRoleName]) || {};
                    if (!_.isEmpty(IamRole)) {
                        this.kecIamRoleId = IamRole.RoleId;
                    } else {
                        Message.error(this.$trans(`输入的IAM角色无效`)); //输入的IAM角色无效
                    }
                }
                let tagSet = _.get(data, 'tagInfo', []);
                if(tagSet.length) {
                    _.forEach(tagSet, (item) => {
                        item.tagKey = item.Key,
                        item.tagValue = item.Value
                    });
                    this.tagSelectList = tagSet;
                    this.addTagToDisk = _.get(data, 'SyncTag', false);
                }

                this.isAutoDelete = _.get(data, 'FailureAutoDelete', false);
                this.isProtect = _.get(data, 'IsProtect', false);
                
            }
        },

        //读取云主机项目制接口
        _fetchProjectList() {
            return this.$store.dispatch(step4Const.getProjects, {
                type: 'DescribeInstances',
                Region: this.regionKey,
            }).then((res) => {
                // this.projectnames = _.map(this.project.list, 'ProjectName')
                if (!_.has(this.dedicatedObj, 'ProjectId')) {
                    this.projectnames = _.forEach(this.projectlist, (item) => {
                        item.title = item.ProjectName;
                        item.value = item.ProjectId;
                    })
                    if(!this.checkedProjectValue){
                        this.checkedProject = this.projectnames[0] || '';
                    }
                } else {
                    let idx = 0;
                    this.projectnames = _.forEach(this.projectlist, (item, index) => {
                        if (item.ProjectId === this.dedicatedObj.ProjectId) {
                            idx = index;
                        }
                        item.title = item.ProjectName;
                        item.value = item.ProjectId;
                    })
                    this.checkedProject = this.projectnames[idx] || '';
                }

                // this.projectnames = _.map(this.project.list, 'ProjectName')
                // if (_.isEmpty(this.dedicatedObj)) {
                //     this.projectnames = _.forEach(this.projectlist, (item) => {
                //         item.title = item.ProjectName
                //         item.value = item.ProjectId
                //     })
                //     this.checkedProject = this.projectnames[0] || ''
                // } else {
                //     this.projectnames = []
                //     _.forEach(this.projectlist, (item) => {
                //         if (item.ProjectId === this.dedicatedObj.ProjectId) {
                //             item.title = item.ProjectName
                //             item.value = item.ProjectId
                //             this.projectnames.push(item);
                //         }
                //     })
                //     this.checkedProject = this.projectnames[0] || ''
                // }
            });
        },
        //读取标签列表
        _fetchTagData() {

            var self = this;
            return this.$store.dispatch(step4Const.getTagKeysList, {
                params: {
                    Region: self.regionKey
                }
            }).then(() => {
                var tagKeySet = self.tagKeySet.TagKeySet;
                self.tagKeyList = _.map(tagKeySet, (item) => {
                    item.Value = item.Key;
                    return item;
                });

            });
        },
        //获取容灾组列表
        _fetchAvoidList(resID) {

            var self = this;
            return this.$store.dispatch(step4Const.getAvoidList, {
                params: {
                    Region: self.regionKey
                }
            }).then(() => {
                var avoidList = this.avoidListSet.DataGuardsSet;

                //竞价实例不支持故障域级别容灾组
                if (self.billType == 810) {
                    avoidList = _.filter(avoidList, (item) => {
                        return item.DataGuardType == 'host';
                    });
                }
                
                avoidList = (avoidList || []).map(item => {
                    var temp = item.DataGuardCapacity - item.DataGuardUsedSize;
                    var less = (temp) >= 0 ? temp : 0;
                    var level = item.DataGuardType;
                    if (level == 'host') {
                        level = this.$trans(`机器级别`);
                    } else if (level == 'domain') {
                        level = this.$trans(`故障域级别`);
                    }

                    return {
                        value: item.DataGuardId,
                        title: item.DataGuardName,
                        level: level,
                        total: item.DataGuardCapacity,
                        used: item.DataGuardUsedSize,
                        disabled: less <= 0 || (less < self.kecCount),
                        less: less
                    }
                });
                var canUse = _.filter(avoidList, (item) => {
                    return !item.disabled;
                });
                var cantUse = _.filter(avoidList, (item) => {
                    return item.disabled;
                });
                avoidList = [{
                    value: '',
                    title: this.$trans(`选择容灾组`), //'选择容灾组'
                }].concat(canUse.concat(cantUse));
                // avoidList.push({
                //     value: 'new',
                //     title: this.$trans(`新建容灾组`), //'新建容灾组'
                // });
                this.avoidNameList = _.map(avoidList, 'title');
                this.avoidList = avoidList;
                if (resID) {

                    this.avoidObj = _.find(avoidList, (item) => {
                        return item.value == resID;
                    }) || avoidList[0];
                } else {
                    if (!_.find(avoidList, (item) => {
                        return item.value == this.avoidObj.value
                    })) {
                        this.avoidObj = avoidList[0];
                    }
                }

            });
        },
        _fetchDate() {
            return this.$store.dispatch(step4Const.getTimeddelDate,{
                options: {
					isJSON: true
				},
                data:{
                    Hours: 1,
                },
                params: {
                    Region: this.regionKey
                }
            }).then((data) => {
                this.todelTime = data.time;
                this.minTime = data.time;
                return this.minTime;
            }).catch((e) => {

                commonAlert.send(e, 'kecDanger');
            });
        },
        _setSuf(boo) {
            this.isAddSuf = boo;
            this.dataBind()
        },
        _avoidIdChange() {
            var avoidId = this.avoidObj.value;
            var avoidList = this.avoidList;

            if (avoidId && avoidId != 'new') {
                this.avoidCreate = 'no';
                var avoidInfo = _.find(avoidList, (item) => {
                    return item.value == avoidId;
                }) || {};
                var count = this.kecCount;
                if (avoidInfo.less < count) {
                    commonAlert.send(this.$trans(`容灾组容量不足`), 'kecDanger'); //容灾组容量不足
                    this.avoidObj = {
                        value: '',
                        title: this.$trans(`选择容灾组`), //'选择容灾组'
                    };
                }

            } else if (avoidId == 'new') {

                this.newAvoidGroupName = '';
                this.avoidCreate = 'yes';
                this.avoidObj = {
                    value: '',
                    title: this.$trans(`选择容灾组`), //'选择容灾组'
                };
                this.avoidPrice = 0.00;
            }
        },
        _createAvoid() {
            var newName = this.newAvoidGroupName;
            if ($(this.$el).find('[name="newAvoidGroupName"]').valid()) {
                if (this.avoidCreate == 'newing') return;
                this.avoidCreate = 'newing';
                return this.$store.dispatch(step4Const.createAviod, {
                    params: {
                        Region: this.regionKey,
                        DataGuardName: newName
                    }
                }).then(() => {
                    var res = this.createAvoidSet;
                    this.avoidCreate = 'no';
                    this.checkAvoidStatus = false;
                    var resID = res.DataGuardId || '';
                    return this._fetchAvoidList(resID);
                });
            }
        },
        cancelCreateAvoid() {
            this.avoidCreate = 'no';
            this.checkAvoidStatus = false;
        },
        _tagKeyChange(index, data) {
            var tagKey = data;
            var self = this;
            // if (tagKey && $(this.$el).find('[name="tagKey"]').valid()) {
                return this.$store.dispatch(step4Const.describeTagValues, {
                    params: {
                        Region: self.regionKey,
                        tagKey: tagKey
                    }
                }).then(() => {
                    var tagValueSet = this.tagValueSet.TagValueSet;
                    this.tagSelectList[index].tagValueList = _.map(tagValueSet, (item) => {
                        item.Key = item.Value;
                        return item;
                    });
                });
            // }
        },
        _fetchAvoidConfig() {
            var self = this;
            return this.$store.dispatch(step4Const.getAvoidPackage, {
                params: {
                    Region: this.regionKey,
                    productGroupId: 134
                }
            }).then(() => {
                // console.log(this.avoidSet)
                return this.judgeAvoidConfig();
            }).catch(e => {
                return this.hasAvoidConfig = false;
            });
        },
        judgeAvoidConfig() {
            var regions = this.avoidSet.data.productTypeList[0].regionList
            if (regions.length > 0) {
                var regionKey = this.regionKey;
                if (regionKey == 'cn-beijing-5') { //vpc里的这个机房实际是basic机房
                    this.hasAvoidConfig = false;
                } else {
                    var region = _.find(regions, (item) => {
                        return item.regionCode == regionKey;
                    });
                    if (region) {
                        this.hasAvoidConfig = true;
                    } else {
                        this.hasAvoidConfig = false;
                    }
                }
            } else {
                this.hasAvoidConfig = false;
            }
        },
        mappingSome(type, value) {
            var self = this;
            var res;
            switch (type) {
                case 'region':
                    res = (_.find(self.bossRegionList, (item) => {
                        return item.region_code == value;
                    }) || {}).region_name;
                    break;
                case 'dedicateRegion':
                    res = (_.find(self.queryDedicatedListCopy, (item) => {
                        return item.region_code == value;
                    }) || {}).region_name;
                    break;
                case 'dedicateAz':
                    res = self.azNameMap[value];
                    break;
                case 'orderBill':
                    res = (_.find(self.orderBills, (item) => {
                        return item.billType == value;
                    }) || {}).name;
                    break;
                case 'dedicateOrderBill':
                    res = (_.find(self.dedicatePriceMethod, (item) => {
                        return item.billType == value;
                    }) || {}).name;
                    break;
                case 'dedicateInstanceType':
                    res = (_.find(self.dedicatedKecType, (item) => {
                        return item.id == value;
                    }) || {}).name;
                    break;
                case 'kecType':
                    res = (_.find(self.kecTypeList, (item) => {
                        return item.p_type == value;
                    }) || {}).p_name;
                    break;
                case 'isEnhance':
                    res = value ? ' ' + self.$trans(`支持联网增强`) : '';
                    break;
                case 'hasAz':
                    res = value ? ("(" + self.azName + ")") : '';
                    break;
                case 'imageId':
                    res = self.imageObj.title;
                    break;
                case 'sysDiskObj':
                    res = this.kecType == '41' ? res = self.$trans(`本地硬盘`) : value.title;
                    break;
                case 'diskObj':
                    this.snapInfo.snapChoose ? res = this.snapInfo.snapCpacity : res = value.title;
                    break;
                case 'kecCount':
                    res = value;
                    break;
                case 'duration':
                    this.orderBill == 2017 ? res = this.tryOrderDay : res = value;
                    break;
                case 'eipOrderBill':
                    res = (_.find(self.eipProduct.priceMethods, (item) => {
                        return item.billType == value;
                    }) || {}).name;
                    break;
                case 'bwsOrderBill':
                    res = (_.find(self.bws.priceMethods, (item) => {
                        return item.billType == value;
                    }) || {}).name;
                    break;
                case 'ebsDiskObj':
                    res = (value || {}).title;
                    break;
                case 'ebsDiskSizeList':
                    res = (_.map(value, (item) => {
                        return item = item + 'GB';
                    })).join('/');
                    break;
                case 'hint':
                    self.$el && $(self.$el).find('[name="instanceNameSuffixol"]').valid() ? res = self.$trans(`示意`) + ': ' + (self.serverName || "xxx") + '-' + +self.instanceNameSuffixol + ', ' + (self.serverName || "xxx") + '-' + (+self.instanceNameSuffixol + 1) + ', ...' : res = '';
                    break;
                case 'hostHint':
                    if (self.cloudInitSupport && !self.isAndroidImage && self.$el && $(self.$el).find('[name="hostNameSuffixol"]').length > 0) {
                        $(self.$el).find('[name="hostNameSuffixol"]').valid() ? res = self.$trans(`示意`) + ': ' + (self.hostName || "xxx") + '-' + +self.hostNameSuffixol + ', ' + (self.hostName || "xxx") + '-' + (+self.hostNameSuffixol + 1) + ', ...' : res = '';
                    } else {
                        res = self.$trans(`示意`) + ': xxx-1, xxx-2, ...';
                    }
                    break;
                default:
                    res = type;
            }
            return res;
        },
        dataBind() {
            var tagList = _.cloneDeep(this.tagSelectList);
            tagList = _.remove(tagList,item=>{
                return item.tagKey != "" && item.tagValue != "";
            })
            tagList = _.forEach(tagList, (item,index)=>{
                delete item.tagValueList;
            })
            var base64Reg = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2,16384}==)$/;
            var isBase64Data = false;
            if (this.userBase64) {
                isBase64Data = base64Reg.test(this.userData);
            } else {
                isBase64Data = false;
            }
            // isBase64Data = base64Reg.test(this.userData);
            // var userData = isBase64Data ? this.userData : btoa(this.userData); //转换为Base64格式文本
            var userData = isBase64Data ? this.userData : Buffer.from(this.userData, 'utf8').toString('base64'); //转换为Base64格式文本

            var outdata = {
                checkedProject: this.checkedProject,
                serverName: this.serverName,
                instanceNameSuffixol: this.instanceNameSuffixol,
                tagList: tagList,
                // tagKey: this.tagKey,
                admin_account: this.admin_account,
                // tagValue: this.tagValue,
                avoidObj: this.avoidObj,
                password: this.password,
                step4Checked: this.step4Checked,
                hasAvoidConfig: this.hasAvoidConfig,
                isAddSuf: this.isAddSuf,
                keepImageLogin: this.loginMode == 'useImageConfig',
                keyIds: this.selectKeyId ? [this.selectKeyId] : [],
                hostName: this.cloudInitSupport && !this.isAndroidImage ? this.hostName : '',
                userData: this.cloudInitSupport && !this.isAndroidImage ? userData : '',
                isAddHostNameSuf: this.isAddHostNameSuf,
                hostNameSuffixol: this.hostNameSuffixol,
                modelName: this.modelName || '',
                kecIamRoleId: this.kecIamRoleId,
                kecIamRoleName: this.kecIamRoleName,
                FailureAutoDelete: this.isAutoDelete,
                isProtect: this.isProtect,
                SyncTag: this.addTagToDisk,
            }

            if ((this.DsourcePage == 'modifyTemplate' || this.DsourcePage == 'buyTemplate') && Object.keys(this.DstartTempData).length) {
                outdata.modelId = this.DstartTempData.ModelId || '';
            }

            if (this.DsourcePage == 'createTheSameConfig' && Object.keys(this.DtheSameConfigData).length) {
                outdata.modelId = this.DtheSameConfigData.ModelId || '';
            }
            if(this.isTiming && this.todelTime){
                outdata.AutoDelteTime = this.todelTime;
            }
            if(this.isTiming){
                outdata.DeleteEip = this.autoDeleteEip; //定时删除时是否同时解绑的EIP
            } else {
                delete outdata.AutoDelteTime
                delete outdata.DeleteEip
            }

            this.$emit('input', outdata)

            // this.$emit('valids',this.step4Checked)
        },
        $step4dataValid() {
            if (!this.selectKeyId && this.loginMode === 'useHaveSSH') {
                this.showErrorInfo = true;
            }
            if (this.avoidObj && this.kecCount > this.avoidObj.less) {
                return false;
            }

            let isValid = $(this.$el).find('#form3').valid();
            if (isValid) {
                var self = this;
                if (self.avoidCreate == "yes") {
                    //还在创建容灾组时
                    this.checkAvoidStatus = true;
                    this.step4Checked = false
                    return false;
                }

                if (self.loginMode == 'password') {
                    //输入密码时的校验

                } else if (self.loginMode == 'useHaveSSH') {
                    //key登录
                    if (!this.selectKeyId) {
                        this.step4Checked = false;
                        this.showErrorInfo = true;
                        return false;
                    }
                    this.showErrorInfo = false;
                } else if (self.loginMode == 'useImageConfig') {
                    //保留image设置

                }
                //tag判断
                let alltag =[],tagObj=true;
                _.forEach(this.tagSelectList, item=>{
                    alltag.push(item.tagKey);
                    // if((item.tagKey!='' && item.tagValue=='')||(item.tagKey=='' && item.tagValue!='')){
                    if(item.tagKey=='' || item.tagValue==''){
                        Message.error('标签分类和标签名称不可有一个为空');
                        tagObj =  false;
                    }
                })

                if(tagObj){
                    if(alltag.length != [...new Set(alltag)].length){
                        Message.error('多个标签分类值不可相同');
                        return false;
                    }
                }else {
                    return tagObj;
                }
                if(self.isTiming){
                    this.$store.dispatch(step4Const.getTimeddelDate,{
                        options: {
                            isJSON: true
                        },
                        data:{
                            Minutes: 30,
                        },
                        params: {
                            Region: this.regionKey
                        }
                    }).then((data) => {
                        if(new Date(this.todelTime).getTime() - new Date(data.time).getTime()<=30*60*60){
                            this.deltimeError = true
                            this.step4Checked = false
                        }
                    }).catch((e) => {

                        commonAlert.send(e, 'kecDanger');
                    });
                    this.step4Checked = true
                    return true;
                }
                this.step4Checked = true
                return true;
            }
            this.step4Checked = false
            this.dataBind()
            return false;
        },
        //获取ssh密钥列表
        _getSSHData() {
            return this.$store.dispatch(step4Const.describeKeys, {
                options: {
                    isJSON: true
                },
                data: {
                    Marker: 0,
                    MaxResults: this.pages.limit,
                },
                params: {
                    Region: this.regionKey
                }
            }).then(() => {
                this.sshList = this.keySet.KeySet;
            }).catch(e => {
                Message.error(e || e.msg);
            });
        },
        createSSHResult() {
            this.isCreateSSH = true;
        },
        createSSHResultOk() {
            this._getSSHData();
        },
        advancedOptions() {
            this.isAdvancedOptions = !this.isAdvancedOptions;
        },
        _sethostNameSuf(boo) {
            this.isAddHostNameSuf = boo;
            this.dataBind()
        },
        addTagList(){
            if(this.tagSelectList.length>=10){
                Message.error("最大可配置10个");
                return;
            }
            this.tagSelectList.push({
                tagKey:'',
                tagValue:'',
                tagValueList:[],
            }),
            this.dataBind()
        },
        delTagList(index){
            this.tagSelectList.splice(index,1);
            this.dataBind()
        },
        tagChange(index, data){
            this._tagKeyChange(index, data)
            // this.$nextTick(() => {
            //     this.dataBind()
            // })

        },
        TagValueChange() {
            // this.$nextTick(() => {
            //     this.dataBind()
            // })

        },

        // 校验秘钥是否为2048位加密
        checkKeyEncryption(){
            return this.$store.dispatch(step4Const.CheckKeyEncryption, {
                options: {
                    isJSON: true
                },
                params: {
                    Region: this.regionKey,
                    KeyIds: this.selectKeyId
                }
            })
        }
    },
    watch: {
        '$parent.step2Data.bindHighDefense':{
            handler(val){
                if(val) {
                    this.autoDeleteEip = false
                }
            }
        },
        tagSelectList:{
            deep:true,
            handler(val){
                this.dataBind()
                if(!val.length){
                    this.addTagToDisk = false
                }
            }
        },
        kecIamRoleId(val) {
            let item = _.find(this.kecIamRolesList, ['RoleId', val]) || {};
            if(!_.isEmpty(item)) {
                this.kecIamRoleName = item.RoleName;
            }
            this.dataBind();
        },
        avoidValue(val){
            this.avoidObj = _.find(this.avoidList,item =>{
                return item.value === val
            })
        },
        avoidObj(val) {
            this.avoidValue = val.value
            this._avoidIdChange();
            this.dataBind()
        },
        newAvoidGroupName(val) {
            val ? this.checkAvoidStatus = false : ''
        },
        // tagKey() {
        //     this._tagKeyChange();
        //     this.dataBind();
        // },
        checkedProjectValue(val){
            this.checkedProject = _.find(this.projectnames,item => {
                return item.value === val
            })
        },
        checkedProject(val) {
            this.checkedProjectValue = val.value
            this.dataBind()
        },
        serverName() {
            this.dataBind()
        },
        modelName() {
            this.dataBind()
        },
        instanceNameSuffixol() {
            this.dataBind()
        },
        // tagValue() {
        //     this.dataBind()
        // },
        password() {
            this.dataBind()
        },
        hasAvoidConfig() {
            this.dataBind()
        },
        kecCount() { },
        // imageType(val) {
        //     this.loginMode = initLoginMode(this);
        //     this.loginModeOptions = createLoginModeOptions(this);
        //     this.dataBind();
        // },
        // 'imageObj.Platform': function (val) {
        //     this.loginMode = initLoginMode(this);
        //     this.loginModeOptions = createLoginModeOptions(this);
        //     this.dataBind();
        // },
        loginMode() {
            // if (this.loginMode == 'randomPassword' || this.loginMode == 'useImageConfig') {
            //     this.password = '';
            //     this.selectKeyId = '';
            // } else if (this.loginMode === 'useHaveSSH') {
            //     this.password = '';
            // }
            this.password = '';
            this.selectKeyId = '';
            this.dataBind();
        },
        dedicatedObj() {
            this.dataBind();
            // console.log(this.dedicatedObj, 123);
        },
        async selectKeyId(val){
            if(this.isRockylinuxImage && val){
                try{
                    let res = await this.checkKeyEncryption()
                    if(res?.code !== 200){
                        this.selectKeyId = ''
                        Message.error(res?.msg)
                    }
                    
                } catch(e) {
                    console.log(e)
                }
            }
            val ? this.showErrorInfo = false : '';
            this.dataBind();
        },
        // 'imageObj.imageVersion': function (val) {
        //     this.loginMode = initLoginMode(this);
        //     this.loginModeOptions = createLoginModeOptions(this);
        //     this.dataBind();
        // },
        hostName() {
            this.dataBind();
        },
        userData() {
            this.dataBind();
        },
        userBase64() {
            this.dataBind();
        },
        hostNameSuffixol() {
            this.dataBind();
        },
        isTiming(val){
            if(val){
                this.isProtect = false
            }
            this.dataBind();
        },
        todelTime(){
            if(this.isTiming){
                this.dataBind();
            }
        },
        autoDeleteEip() {
            if (this.isTiming) {
                this.dataBind();
            }
        },
        imageChangeData(val){
            const platform = val?.Platform || val?.imageVersion
            this.isRockylinuxImage = platform?.toLowerCase().includes('rocky')
            if(this.isRockylinuxImage){
                this.selectKeyId = ''
            }
            this.loginMode = initLoginMode(this);
            this.loginModeOptions = createLoginModeOptions(this);
            this.dataBind();
        },
        '$route.path':{
            immediate: true,
            handler(val){
                if(val === '/kec/create'){
                    this.showAutoDelete = true
                } else {
                    this.showAutoDelete = false
                }
            }
        },
        isAutoDelete(val){
            if(val){
                this.isProtect = false
            }
            this.dataBind();
        },
        isProtect(val){
            if(val){
                this.isAutoDelete = false
                this.isTiming = false
            }
            this.dataBind();
        },
        addTagToDisk(){
            this.dataBind();
        }
    },
    mounted() {
        var self = this;
        $.extend($.validator.messages, {
            required: function () {
                return self.$trans(`必须填写`);
            }, //"必须填写"
            remote: function () {
                return self.$trans(`验证不通过`);
            }, //验证不通过
            email: function () {
                return self.$trans(`请输入有效的邮箱`);
            }, //请输入有效的邮箱
            url: function () {
                return self.$trans(`请输入有效的网址`);
            }, //请输入有效的网址
            date: function () {
                return self.$trans(`请输入有效的日期`);
            }, //请输入有效的日期
            dateISO: function () {
                return self.$trans(`请输入有效的日期 （YYYY-MM-DD）`);
            }, //请输入有效的日期 (YYYY-MM-DD)
            number: function () {
                return self.$trans(`请输入正确的数字`);
            }, //请输入正确的数字
            digits: function () {
                return self.$trans(`只可输入整数`);
            }, //只可输入整数
            creditcard: function () {
                return self.$trans(`请输入有效的信用卡号码`);
            }, //请输入有效的信用卡号码
            equalTo: function () {
                return self.$trans(`两次输入密码不一致`);
            }, //两次输入密码不一致
            extension: function () {
                return self.$trans(`请输入有效的后缀`);
            }, //请输入有效的后缀
            maxlength: function () {
                return self.$trans(`最多{0}个字符`, arguments[0]);
            }, //最多{0}个字符
            minlength: function () {
                return self.$trans(`最少{0}个字符`, arguments[0]);
            }, //最少{0}个字符
            rangelength: function () {
                return self.$trans(`请输入长度为 {0} 至 {1} 之间的字符`, arguments[0][0], arguments[0][1]);
            }, //请输入长度为 {0} 至 {1} 之间的字符
            range: function () {
                return self.$trans(`请输入 {0} 至 {1} 之间的数`, arguments[0][0], arguments[0][1]);
            }, //请输入 {0} 至 {1} 之间的数
            max: function () {
                return self.$trans(`请输入不大于{0}的数值`, arguments[0]);
            }, //请输入不大于 {0} 的数"
            min: function () {
                return self.$trans(`请输入不小于{0}的数值`, arguments[0]);
            }, //请输入不小于 {0} 的数
            step: function () {
                return self.$trans(`请输入{0}的倍数`, arguments[0]);
            } //请输入{0} 的倍数数
        });
        $.validator.addMethod("isName", function (value, element) {
            var tel = /^[0-9a-zA-Z\u4e00-\u9fa5-,_\.!@#\$%\^&\*\(\)\?\+\/\:\;><=\[\]\`\{\}\|~]{2,64}$/;
            self.isServeName = this.optional(element) || (tel.test(value));
            return this.optional(element) || (tel.test(value));
        }, self.$trans('2-64个字符，支持中文，英文，数字，以及特殊字符-,.!$^*（）%#&+/：；<=>[]_`{|}~')); //2-64个字符，支持中文，英文，数字，以及特殊字符-,.!@$^*()%#&+/:;<=>[]_`{|}~
        $.validator.addMethod("isOldName", function (value, element) {
            var tel = /^[0-9a-zA-Z\u4e00-\u9fa5-_]{2,64}$/;
            return this.optional(element) || (tel.test(value));
        }, self.$trans(`2-64个字符，支持中文，字母，数字，以及-_`));
        $.validator.addMethod("isAvoidNameSame", function (value, element) {
            var avoidNameList = self.avoidNameList;
            var isPass = _.indexOf(avoidNameList, value);
            return isPass == -1;
        }, self.$trans(`您输入的名称已存在`)); //您输入的名称已存在
        $.validator.addMethod("ispwd", function (value, element) {
            var tel = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])([a-zA-Z0-9!"\$%\(\)\*\+,\#\-\.\/:;<=>\?@\[\]\^_`\{\|\}~]{8,32})$/;
            return this.optional(element) || (tel.test(value));
        }, self.$trans(`请填写正确的密码格式`)); //请填写正确的密码格式
        $.validator.addMethod("dedicateCpu", function (value, element) {
            return self.dedicateCpuCal();
        }, self.$trans(`CPU不足以分配`)); //CPU不足以分配
        $.validator.addMethod("dedicateMem", function (value, element) {
            return self.dedicateMemCal();
        }, self.$trans(`内存不足以分配`)); //内存不足以分配
        $.validator.addMethod("dedicateDisk", function (value, element) {
            return self.dedicateDiskCal();
        }, self.$trans(`数据盘不足以分配`));
        $.validator.addMethod("actualCpu", function (value, element) {
            return self.dedicateActualCpuCal();
        }, self.$trans(`单台可分配的最大核数不可超过实际核数`));
        $.validator.addMethod("tagKey", function (value, element) {
            if (value == '') return true;
            var headString = value.substr(0, 3);
            var reg = /^[\u0020-\u00FF\u4E00-\u9FFF]{1,127}$/i;
            return (headString.toLowerCase() != 'ksc') && reg.test(value);
        }, self.$trans(`1-127个非ksc开头中文或英文可见字符`)); //1-127个非ksc开头中文,英文可见字符
        $.validator.addMethod("tagValue", function (value, element) {
            if (value == '') return true;
            var reg = /^[\u0020-\u00FF\u4E00-\u9FFF]{1,255}$/;
            return reg.test(value);
        }, self.$trans(`1-255个英文可见字符,中文`)); //1-255个英文可见字符,中文
        $.validator.addMethod("isHostName", function (value, element) {
            // window实例效验规则： 2-15个字符，支持英文、数字和短横线（-），不可全是数字，首尾不可使用短横线，不可连续使用短横线
            // linux实例效验规则： 2-64个字符，支持英文、数字、短横线（-）、点号(.)，首尾不可使用短横线或点号，不可连续使用短横线或点号
            // 编译系统不支持(?<![-.])后断言 所以通过后面补充逻辑 单独处理
            var reg_windows = /^(?!-)(?![0-9]*$)([a-zA-Z0-9-](?![-]{2,})){2,15}$/;
            var reg_linux = /^(?![-.])([a-zA-Z0-9-.](?![-.]{2,})){2,64}$/;

            // 提示：JavaScript 语言的正则表达式，只支持先行断言（lookahead）和先行否定断言（negative lookahead），不支持后行断言（lookbehind）和后行否定断言（negative lookbehind）。ES2018 引入后行断言，V8 引擎 4.9 版（Chrome 62）已经支持。
            var lastStr = value.charAt(value.length - 1);
            var isValid = this.optional(element) || (self.isWindows ? (reg_windows.test(value) && lastStr !== '-') : (reg_linux.test(value) && lastStr !== '-' && lastStr !== '.'));
            self.isHostNameValid = isValid;
            return isValid
        }, function () {
            return self.isWindows ? "2-15个字符，英文、数字和短横线(-)，不可全数字，首尾不可短横线，不可连续短横线" : "2-64个字符，英文、数字、短横线(-)、点号(.)，首尾不可短横线或点号，不可连续短横线或点号";;
        });
        $.validator.addMethod("isBase64Data", function (value, element) {
            if (self.userBase64) {
                var base64Reg = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2,16384}==)$/;
                return base64Reg.test(value);
            } else {
                return true;
            }
        }, "输入内容不符合Base64格式，最大支持16KB"); //输入内容不符合Base64格式，最大支持16KB
        $.validator.addMethod("isUserData", function (value, element) {
            var base64Reg = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2,16384}==)$/;
            var isBase64Data = false;
            if (self.userBase64) {
                isBase64Data = base64Reg.test(value);
            } else {
                isBase64Data = false;
            }
            // debugger;
            // var val = isBase64Data ? value : btoa(value); //转换为Base64格式文本
            var val = isBase64Data ? value : Buffer.from(value, 'utf8').toString('base64'); //转换为Base64格式文本
            var num = 16 * 1024; //16k限制
            return this.optional(element) || val.length < num;
        }, "不能超过16KB"); //不能超过16KB
        $.validator.addMethod("ismodelName", function (value, element) {
            var reg = /^[0-9a-zA-Z\u4e00-\u9fa5-,_\.!@#\$%\^&\*\(\)\?\+\/\:\;><=\[\]\`\{\}\|~]{2,64}$/;
            return this.optional(element) || (reg.test(value));
        }, self.$trans('2-64个字符，支持中文，英文，数字，以及特殊字符-,.!$^*（）%#&+/：；<=>[]_`{|}~')); //2-64个字符，支持中文，英文，数字，以及特殊字符-,.!@$^*()%#&+/:;<=>[]_`{|}~
    }

}

